import React from 'react';
import { useLocation } from 'react-router-dom';
import { RestaurantEventsAddEditForm } from './_form';

export const RestaurantEventsAddNew = () => {
  const location = useLocation();
  const { search } = location;

  const sp = new URLSearchParams(search);
  const restaurantFromUrl = sp.get('restaurant');

  return <RestaurantEventsAddEditForm isEdit={false} initialRestaurant={restaurantFromUrl} />;
};
